<app-header></app-header>

<main class="flex-grow-1">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

@if (radioEnabled()) {
  <app-radio-player [isPage]="currentRoute() === '/opus'"></app-radio-player>
}
